import { Component, OnInit } from '@angular/core';
import { Mezzo } from 'src/app/def/structures';
import { DBFirestoreService } from 'src/app/dbfirestore.service';
import { Observable } from 'rxjs';
import { BatchOperation } from 'src/app/def/types';

@Component({
    selector: 'odl-admin-mezzi',
    templateUrl: './mezzi.component.html',
    styleUrls: ['./mezzi.component.scss']
})
export class OdlAdminMezziComponent implements OnInit {

    mezzi: Mezzo[] = [];
    newmezzi: Partial<Mezzo>[] = [];
    newrow: Partial<Mezzo> = {
        nome: '',
        targa: '',
    }

    batchops: BatchOperation[] = [];
    toDelete: string[] = [];

    constructor(
        private db: DBFirestoreService
    ) { }

    ngOnInit() {
        this.db.collectionMezzi(true).subscribe( mezzi => {
            console.log('update');
            this.mezzi = mezzi.reverse();
        });
    }

    addNew() {
        if ( !this.newrow.nome || !this.newrow.targa) {
            return;
        }
        this.newmezzi.push({
            nome: this.newrow.nome,
            targa: this.newrow.targa,
            disabled: false,
        })
        this.newrow.nome = '';
        this.newrow.targa = '';
        
        this.commit();
    }

    delete(mezzo) {
        if ( !confirm('Questa operazione eliminerà in modo permanente il mezzo. Piuttosto che cancellarlo, è consigliabile disattivarlo per non perdere l\'associazione con gli ordini inseriti.'+"\n\n"+' Sei sicuro di voler procedere?') ) {
            return;
        }
        console.log(mezzo);
        this.db.deleteMezzo(mezzo).then( () => {
            console.log('deleted');

        }).catch( error => {
            this.onError('errore cancellazione mezzo', error)
        });
    }

    disable(mezzo) {
        mezzo.disabled= true;
        this.db.updateMezzo(mezzo).catch( error => {
            alert('Operazione non riuscita');
            console.log(error);
        })
    }

    enable(mezzo) {
        mezzo.disabled= false;
        this.db.updateMezzo(mezzo).catch( error => {
            alert('Operazione non riuscita');
            console.log(error);
        })
    }

    delNew(idx) {
        this.newmezzi.splice(idx,1);
    }

    commit() {
        this.addNew();
        this.batchops = [];
        this.batchops = this.newmezzi.map( mezzo => {
            return this.db.batchAddMezzo({
                id: null,
                nome: mezzo.nome,
                targa: mezzo.targa,
                disabled: false,
            });
        });
        this.db.batch(this.batchops).then( result => {
            this.batchops = [];
        }).catch( error => {
            this.onError('Errore procedura di aggiornamento', error)
        });
    }

    onError(title: string, extra: any) {
        alert(title);
        console.log(extra);
    }

}
